import { useQuery } from 'react-query';
import { getPnlAccounts } from '~/api/pnlAccounts';

export const usePnlAccounts = () => {
  return useQuery(['pnlAccounts'], () => getPnlAccounts().then((res) => res.data));
};
